import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
const $ = window.jQuery;


const $DOM = {};
let contentSwiper;

const domCache = () => {
    $DOM.container = $(".slider-content");
    if(!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".slider-content-swiper-container");
}

const initSwiper = () => {
    contentSwiper = new Swiper($DOM.swiperContainer[0], {
        modules: [Pagination, A11y, Navigation,Keyboard],
        init: false,
        spaceBetween: 18,
        speed: 300,
        preventClicksPropagation: false,
        roundLengths: true,
        loop: false,
        grabCursor: true,
        a11y: true,
        slidesPerView: 1.1,
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        pagination: {
            el: '.swiper-pagination-links',
            clickable: true
        },
        breakpoints: {
            420: {
                slidesPerView: 2.2
            },
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
            1200 : {
                slidesPerView: 5,
            }
        },
    });

    contentSwiper.on("init", onInit);
    contentSwiper.on("slideChange", onSlideChange);
    contentSwiper.init();
}

const onInit = () => {
    $DOM.swiperContainer.addClass("is-init");
}

const onSlideChange = () => {

}




const sliderContent = {
    init: () => {
        domCache();
        if(!$DOM.container.length) {
            return;
        }
        initSwiper();
    }
};

export default sliderContent;
